import { routesModel } from '@Router/router.consts';
import { RoutesMap } from '@Router/router.types';
import { useBoundStore } from '@Store/index';
import { OnboardingFormFields } from '@Types/index';
import { ErrorType } from '@Services/errors/errorType.ts';
import type { IErrorHandling } from '@Types/index';

export const PersonalErrorMap = {
  INVALID_FIRST_NAME: { errorCode: 4047, errorType: ErrorType.BUSINESS_LOGIC },
  INVALID_LAST_NAME: { errorCode: 4048, errorType: ErrorType.BUSINESS_LOGIC },
  INCORRECT_AGE: { errorCode: 4078, errorType: ErrorType.BUSINESS_LOGIC },
  MUST_BE_OLDER_THAN: { errorCode: 4028, errorType: ErrorType.BUSINESS_LOGIC },
  NAME_TOO_LONG: { errorCode: 4094, errorType: ErrorType.BUSINESS_LOGIC },
  ID_ALREADY_EXISTS: { errorCode: 40511, errorType: ErrorType.BUSINESS_LOGIC },
  NAME_TOO_LONG_V2: { errorCode: 40941, errorType: ErrorType.BUSINESS_LOGIC },
};

export const getPersonalErrorsObjectMap = (): Map<number, IErrorHandling> => {
  return new Map<number, IErrorHandling>([
    [
      PersonalErrorMap.INVALID_FIRST_NAME.errorCode,
      {
        errorCode: PersonalErrorMap.INVALID_FIRST_NAME.errorCode,
        redirectPath: '',
        relatedFieldName: OnboardingFormFields.FIRST_NAME,
        callBack: () => {},
      },
    ],
    [
      PersonalErrorMap.INVALID_LAST_NAME.errorCode,
      {
        errorCode: PersonalErrorMap.INVALID_LAST_NAME.errorCode,
        redirectPath: '',
        relatedFieldName: OnboardingFormFields.LAST_NAME,
        callBack: () => {},
      },
    ],
    [
      PersonalErrorMap.INCORRECT_AGE.errorCode,
      {
        errorCode: PersonalErrorMap.INCORRECT_AGE.errorCode,
        redirectPath: '',
        relatedFieldName: OnboardingFormFields.DATE_OF_BIRTH,
        callBack: () => {},
      },
    ],
    [
      PersonalErrorMap.MUST_BE_OLDER_THAN.errorCode,
      {
        errorCode: PersonalErrorMap.MUST_BE_OLDER_THAN.errorCode,
        redirectPath: '',
        relatedFieldName: OnboardingFormFields.DATE_OF_BIRTH,
        callBack: () => {},
      },
    ],
    [
      PersonalErrorMap.NAME_TOO_LONG.errorCode,
      {
        errorCode: PersonalErrorMap.NAME_TOO_LONG.errorCode,
        redirectPath: routesModel[RoutesMap.DEBIT_CARD_NAME].path,
        relatedFieldName: OnboardingFormFields.FIRST_NAME,
        callBack: () => {},
      },
    ],
    [
      PersonalErrorMap.ID_ALREADY_EXISTS.errorCode,
      {
        errorCode: PersonalErrorMap.ID_ALREADY_EXISTS.errorCode,
        redirectPath: '',
        relatedFieldName: OnboardingFormFields.NATIONAL_ID_NUMBER,
        callBack: () => {},
      },
    ],
    [
      PersonalErrorMap.NAME_TOO_LONG_V2.errorCode,
      {
        errorCode: PersonalErrorMap.NAME_TOO_LONG_V2.errorCode,
        redirectPath: '',
        relatedFieldName: OnboardingFormFields.FIRST_NAME,
        callBack: () => {
          useBoundStore.getState().errorSlice.setIsNameTooLongModalShown(true);
        },
      },
    ],
  ]);
};
